import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ChevronRight } from 'lucide-react';

interface ReflectionCreatedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onViewReflection: () => void;
}

const ReflectionCreatedModal: React.FC<ReflectionCreatedModalProps> = ({
  isOpen,
  onClose,
  onViewReflection,
}) => {
  if (!isOpen) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 backdrop-blur-sm"
    >
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.95, opacity: 0 }}
        className="bg-white rounded-xl shadow-xl max-w-md w-full p-6"
      >
        <div className="flex items-center justify-center mb-6">
          <div className="h-12 w-12 bg-gradient-to-r from-purple-100 to-pink-100 rounded-full flex items-center justify-center">
            <Sparkles className="h-6 w-6 text-purple-600" />
          </div>
        </div>

        <h3 className="text-xl font-semibold text-center text-gray-900 mb-3">
          Your reflection has been saved
        </h3>

        <p className="text-gray-600 text-center mb-6">
          View your personal insights and takeaways from this conversation in your dashboard.
        </p>

        <button
          onClick={() => {
            onClose();
            onViewReflection();
          }}
          className="w-full py-3 bg-gradient-to-r from-[#a85ff7] to-[#e457b5] text-white rounded-lg hover:opacity-90 transition-opacity font-medium flex items-center justify-center"
        >
          View Your Reflection
          <ChevronRight className="h-5 w-5 ml-2" />
        </button>
      </motion.div>
    </motion.div>
  );
};

export default ReflectionCreatedModal;